import { useQuery } from "@tanstack/react-query";
import { useInfrastructureApiClient } from "../../../../../hooks";
import { ROUTES } from "../../../../../routes";
import { EquipmentTree } from "../../../../Infrastructure/EquipmentTree";
import { useMapData } from "../../../hooks/mapDataAndFilters";
import { SidebarSection } from "../../../ui/SidebarItems";
import {
    PipelineSegmentSidebarDisplay,
    PipelineSidebarDisplay,
    SiteSidebarDisplay,
} from "./common";

export const InfrastructureTab = () => {
    const apiClient = useInfrastructureApiClient();
    const { selectedContext } = useMapData("mainMap");

    // Fetch main item information
    const siteQuery = useQuery({
        queryKey: ["site", selectedContext.siteId],
        queryFn: async () => {
            return await apiClient.infrastructureSitesRetrieve({
                id: selectedContext.siteId,
            });
        },
        enabled: !!selectedContext.siteId,
    });

    const action = {
        label: "Site",
        fn: () =>
            window.open(
                `${ROUTES.INFRASTRUCTURE_SITE}?site=${siteQuery.data?.id}`,
            ),
    };

    return (
        <div className="w-[400px] h-full bg-white">
            <SidebarSection
                title="General Information"
                loading={siteQuery.isLoading}
                action={action}
            >
                <SiteSidebarDisplay site={siteQuery.data} />
            </SidebarSection>
            <SidebarSection
                title="Related Infrastructure"
                loading={false}
                noPadding
            >
                <EquipmentTree
                    siteId={selectedContext.siteId}
                    columnVisibility={{
                        manufacturerMake: false,
                        manufacturerModel: false,
                        location: false,
                        material: false,
                        fuel: false,
                        operatorStatus: false,
                    }}
                />
            </SidebarSection>
        </div>
    );
};

export const PipelineTab = () => {
    const apiClient = useInfrastructureApiClient();
    const { selectedContext } = useMapData("mainMap");

    // Fetch main item information
    const itemQuery = useQuery({
        queryKey: ["pipeline", selectedContext.pipeline.id],
        queryFn: async () => {
            return await apiClient.infrastructurePipelineRetrieve({
                id: selectedContext.pipeline.id,
            });
        },
        enabled: !!selectedContext.pipeline,
    });

    // Pipeline Segment
    const segmentQuery = useQuery({
        queryKey: ["pipelineSegment", selectedContext.pipeline],
        queryFn: async () => {
            return await apiClient.infrastructurePipelineSegmentsList({
                pipeline: selectedContext.pipeline.id,
                nearPoint: JSON.stringify({
                    type: "Point",
                    coordinates: selectedContext.pipeline.coordinates,
                }),
            });
        },
        enabled: !!selectedContext.pipeline,
    });

    return (
        <div className="w-[400px] h-full bg-white">
            <SidebarSection
                title="General Information"
                loading={itemQuery.isLoading}
            >
                <PipelineSidebarDisplay pipeline={itemQuery.data} />
            </SidebarSection>
            <SidebarSection
                title="Pipeline Segment"
                loading={segmentQuery.isLoading}
            >
                {segmentQuery.data?.results.map((segment) => (
                    <PipelineSegmentSidebarDisplay
                        key={segment.id}
                        segment={segment}
                    />
                ))}
            </SidebarSection>
        </div>
    );
};
